<div [ngClass]="{'flex-column': !dense}" class="d-flex align-items-center justify-content-center">
    <fa-icon [icon]="['far', icon]" size="lg"></fa-icon>
    <p [ngClass]="dense ? 'ml-2' : 'mt-2'" class="m-0">{{ 'common.no_items_found_short' | translate : { value: resource } }}</p>
</div>
<a (click)="action.emit()" *ngIf="actionEnabled" class="small" href="javascript:void(0);">{{actionLabel}}</a>
